<template>
  <div class="container">
    <form @submit.prevent="submitForm" v-if="show_form" :class="state">
      <div class="form-floating mb-4">
        <input
          type="text"
          id="name"
          class="form-control"
          name="name"
          placeholder="Vorname Nachname"
          required
          v-model="formdata.name"
        />
        <label for="name">{{ translations.name }}</label>
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-floating mb-4">
            <input
              type="email"
              id="email"
              class="form-control"
              name="email"
              placeholder=""
              required
              v-model="formdata.email"
            />
            <label for="email">{{ translations.email }}</label>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-floating mb-4">
            <input
              type="text"
              id="phone"
              class="form-control"
              name="phone"
              placeholder=""
              v-model="formdata.phone"
            />
            <label for="phone">{{ translations.phone }}</label>
          </div>
        </div>
      </div>

      <div class="form-floating mb-4">
        <input
          type="text"
          id="street"
          class="form-control"
          name="street"
          placeholder=""
          v-model="formdata.street"
        />
        <label for="street">{{ translations.street }}</label>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-floating mb-4">
            <input
              type="text"
              id="postalcode"
              class="form-control"
              name="postalcode"
              placeholder=""
              maxlength="5"
              v-model="formdata.postalcode"
            />
            <label for="postalcode">{{ translations.plz }}</label>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="form-floating mb-4">
            <input
              type="text"
              id="city"
              class="form-control"
              name="city"
              placeholder=""
              v-model="formdata.city"
            />
            <label for="city">{{ translations.ort }}</label>
          </div>
        </div>
      </div>

      <div class="form-floating mb-4">
        <select
          id="category"
          class="form-control"
          name="category"
          required
          v-model="formdata.category"
        >
          <option value="" disabled selected>
            {{ translations.pls_select }}
          </option>
          <option value="Personal">{{ translations.personal }}</option>
          <option value="Fahrplan">{{ translations.fahrplan }}</option>
          <option value="Sonstige">{{ translations.sonstige }}</option>
        </select>
        <label for="category">{{ translations.category }}</label>
      </div>

      <div class="form-floating mb-4">
        <!-- Keine Kategorie -->
        <select
          id="complaintreason"
          class="form-control"
          name="beschwerdegrund"
          disabled
          v-if="!formdata.category"
        >
          <option value="" disabled selected>
            {{ translations.pls_select }}
          </option>
        </select>
        <!-- Keine Kategorie -->

        <!-- Kategorie Personal -->
        <template v-if="formdata.category == 'Personal'">
          <select
            id="complaintreason1"
            class="form-control"
            name="complaintreason"
            required
            v-model="formdata.complaintreason"
          >
            <option value="" selected disabled>
              {{ translations.pls_select }}
            </option>
            <option
              v-for="(beschwerde, index) in beschwerden_personal"
              :value="beschwerde"
              :key="index"
            >
              {{ beschwerde }}
            </option>
          </select>
        </template>
        <!-- Kategorie Personal -->

        <!-- Kategorie Fahrplan -->
        <template v-if="formdata.category == 'Fahrplan'">
          <select
            id="complaintreason2"
            class="form-control"
            name="beschwerdegrund"
            required
            v-model="formdata.complaintreason"
          >
            <option value="" disabled selected>
              {{ translations.pls_select }}
            </option>
            <option
              v-for="(beschwerde, index) in beschwerden_fahrplan"
              :value="beschwerde"
              :key="index"
            >
              {{ beschwerde }}
            </option>
          </select>
        </template>
        <!-- Kategorie Fahrplan -->

        <!-- Kategorie Sonstige -->
        <template v-if="formdata.category == 'Sonstige'">
          <select
            id="complaintreason3"
            class="form-control"
            name="beschwerdegrund"
            required
            v-model="formdata.complaintreason"
          >
            <option value="" disabled selected>
              {{ translations.pls_select }}
            </option>
            <option
              v-for="(beschwerde, index) in beschwerden_sonstige"
              :value="beschwerde"
              :key="index"
            >
              {{ beschwerde }}
            </option>
          </select>
        </template>
        <!-- Kategorie Sonstige -->

        <label v-if="formdata.category == 'Personal'" for="complaintreason1">{{ translations.beschwerdegrund }}</label>
        <label v-if="formdata.category == 'Fahrplan'" for="complaintreason2">{{ translations.beschwerdegrund }}</label>
        <label v-if="formdata.category == 'Sonstige'" for="complaintreason3">{{ translations.beschwerdegrund }}</label>
        <label v-if="formdata.category == ''" for="complaintreason">{{ translations.beschwerdegrund }}</label>
      </div>

      <div class="form-floating mb-4" v-if="formdata.category == 'Sonstige' && formdata.complaintreason == 'Sonstiges'">
        <input
          type="text"
          id="complaintreason-other"
          class="form-control"
          name="sonstiges"
          placeholder=""
          required
          v-model="formdata.complaintreasonOther"
        />
        <label for="complaintreason-other">{{ translations.sonstiges }}</label>
      </div>

      <div class="form-floating mb-4">
        <select
          id="linenumber"
          class="form-control"
          name="linenumber"
          required
          v-model="formdata.linenumber"
        >
          <option value="" disabled selected>
            {{ translations.pls_select }}
          </option>
          <option
            v-for="(linnum, index) in liniennummern"
            :value="linnum"
            :key="index"
          >
            {{ linnum }}
          </option>
        </select>
        <label for="linenumber">{{ translations.liniennummer }}</label>
      </div>

      <div class="form-floating mb-4" v-if="formdata.linenumber == 'Sonstige'">
        <input
          type="text"
          id="linenumber-other"
          class="form-control"
          name="sonstige-linie"
          placeholder=""
          required
          v-model="formdata.linenumbeOther"
        />
        <label for="linenumber-other">{{ translations.sonstige2 }}</label>
      </div>
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="form-floating mb-4">
            <input
              type="date"
              id="datetime"
              class="form-control"
              name="datetime"
              required
              placeholder="Datum"
              :max="setCurrentDateAsMaxDate()"
              v-model="formdata.date"
            />
            <label for="datetime">{{ translations.datum }}</label>
          </div>
        </div>
        <div class="col-12 col-md-4">

      <div class="form-floating mb-4">
        <input
          type="time"
          id="datetime-time"
          class="form-control"
          name="datetime-time"
          required
          placeholder="Uhrzeit"
          v-model="formdata.time"
        />
        <label for="datetime">{{ translations.time }}</label>
      </div>
        </div>
      </div>


      <div class="form-floating mb-4">
        <input
          type="text"
          id="station"
          class="form-control"
          name="haltestelle"
          placeholder="Haltestelle / Fahrtrichtung"
          required
          v-model="formdata.station"
        />
        <label for="station">{{ translations.haltestelle }}</label>
      </div>

      <div class="form-floating mb-3">
        <textarea
          id="message"
          class="form-control"
          name="anliegen"
          maxlength="500"
          placeholder=""
          style="height: 200px"
          required
          v-model="formdata.message"
        ></textarea>
        <label for="message">{{ translations.anliegen }}</label>
        <span class="small">{{ translations.max500 }}</span>
      </div>

      <div class="mb-4 feedback">
        <label for="rueckmeldung">{{ translations.rueckmeldung }}</label>
        <span class="info">{{ translations.rueckmeldunginfo }}</span>

        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="rueckmeldung"
            id="feedback-yes"
            value="Ja"
            v-model="formdata.feedback"
          />
          <label class="form-check-label" for="feedback-yes">Ja</label>
        </div>
        <div class="form-check form-check-inline">
          <input
            class="form-check-input"
            type="radio"
            name="rueckmeldung"
            id="feedback-no"
            value="Nein"
            checked
            v-model="formdata.feedback"
          />
          <label class="form-check-label" for="feedback-no">Nein</label>
        </div>
      </div>

      <div class="mb-5 acceptance">
        <div class="form-check">
          <input 
            class="form-check-input" 
            type="checkbox" 
            name="acceptance"
            value=""
            id="acceptance"
            required
          />
          <label class="form-check-label" for="acceptance">
            Ja, ich habe die <a href="/datenschutzerklaerung/" target="_blank">Datenschutzbestimmungen</a> zur Kenntnis genommen und bin damit einverstanden, dass die von mir angegebenen Daten elektronisch erhoben und gespeichert werden. Meine Daten werden dabei nur streng zweckgebunden zur Bearbeitung und Beantwortung meiner Anfrage benutzt. Mit dem Absenden des Formulars erkläre ich mich mit der Verarbeitung einverstanden.
          </label>
        </div>
      </div>

      <input type="submit" :value="translations.submit" />
    </form>
    <div class="sendmessage">
      <template v-if="state == 'ok'">
        <div class="alert alert-success" role="alert">
          <h4 class="alert-heading">{{ translations.ok_state_title }}</h4>
          <p>{{ translations.ok_state_text }}</p>
        </div>
      </template>

      <template v-if="state == 'no'">
        <div class="alert alert-danger" role="alert">
          <h4 class="alert-heading">{{ translations.no_state_title }}</h4>
          <p>{{ translations.no_state_text }}</p>
        </div>
      </template>

      <template v-if="state == 'is_spam'">
        <div class="alert alert-danger" role="alert">
          <h4 class="alert-heading">{{ translations.no_state_title }}</h4>
          <p>{{ translations.no_state_text }}</p>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apiData: "",
      show_form: true,
      state: "",
      formdata: {
        name: "",
        email: "",
        phone: "",
        street: "",
        postalcode: "",
        city: "",
        category: "",
        complaintreason: "",
        complaintreasonOther: "",
        linenumber: "",
        linenumbeOther: "",
        date: null,
        time: null,
        station: "",
        feedback: "Nein",
        message: "",
      },
      forbidden_words: [],
      translations: {
        title: "Beschwerdeformular",
        name: "Name *",
        email: "E-Mail *",
        phone: "Telefon / Mobil",
        street: "Straße, Hausnummer",
        plz: "PLZ",
        ort: "Ort",
        pls_select: "Bitte wählen",
        personal: "Personal",
        fahrplan: "Fahrplan",
        sonstige: "Sonstige",
        category: "Kategorie *",
        beschwerdegrund: "Beschwerdegrund *",
        sonstiges: "Sonstiges *",
        liniennummer: "Linien-Nummer *",
        sonstige2: "Sonstige *",
        datum: "Datum *",
        time: "Uhrzeit *",
        haltestelle: "Haltestelle / Fahrtrichtung *",
        rueckmeldung: "Wünschen Sie eine Rückmeldung zu Ihrem Anliegen? *",
        rueckmeldunginfo: "Wenn Sie eine Rückmeldung wünschen, antworten wir an die oben angegebene E-Mail-Adresse.",
        anliegen: "Ihr Anliegen *",
        max500: "max. 500 Zeichen erlaubt",
        submit: "Formular Absenden",
        ok_state_title: "Vielen Dank für Ihr Feedback",
        ok_state_text:
          "Ihre Anmerkung wurde erfolgreich übermittelt. Wenn gewünscht und ausgewählt, werden wir uns mit Ihnen in Verbindung setzen.",
        no_state_title: "Ihr Feedback konnte nicht übermittelt werden",
        no_state_text:
          "Ihr Feedback konnte nicht übermittelt werden. Eventuell enthält Ihre Nachricht verbotene Wörter. Überprüfen Sie Ihre Angaben und versuchen Sie es erneut.",
      },
      beschwerden_personal: [
        "Anschluss nicht abgewartet",
        "AST/ Personal unfreundlich",
        "Bus nicht abgesenkt an Niederflurhaltestelle",
        "Bus zu früh gefahren",
        "Fahrweise",
        "Haltestelle ausgelassen",
        "Haltewunsch (Knopf) nicht berücksichtigt",
        "Kunde nicht mitgenommen",
        "Kunde rausgeworfen",
        "Linienweg nicht bekannt",
        "raucht/ telefoniert/ Radio",
        "Tarifierung", 
        "unfreundlich",
      ],
      beschwerden_fahrplan: [
        "Bus/ AST Änderungswünsche Fahrplan",
        "Haltestelle/ Aushangfahrplan fehlt/ nicht lesbar",
      ],
      beschwerden_sonstige: [
        "AST/ Bestellung nicht möglich",
        "AST/ Fehlfahrt oder nicht gefahren",
        "Bus/ nicht gefahren",
        "Bus/ Unfall",
        "Bus/ verspätet",
        "Bus/ Zielbeschilderung",
        "Haltestelle/defekt - verschmutzt (AST/Bus)",
        "Sonstiges",
        "zuständig anderes VU",
      ],
      liniennummern: [
        "701",
        "702",
        "703",
        "704",
        "705",
        "706",
        "707",
        "708",
        "709",
        "AST-782",
        "Sonstige",
      ],
    };
  },
  methods: {
    async submitForm() {
      try {
        this.state = "loading";
        
        let response = await fetch(
          "/wp-json/j77_beschwerdeformular/v2/data",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.formdata),
          }
        );

        if (response.ok) {
          const responseData = await response.json();

          if(responseData.is_spam){
            this.state = "is_spam";
            this.show_form = true;
          }else{
            this.state = "ok";
            this.show_form = false;
            window.scrollTo(0, 0);
            
          }
        } else {
          this.state = "no";
          this.show_form = true;
          console.error("Error submitting form:", response.statusText);
        }
      } catch (error) {
        this.state = "no";
        console.error("Unexpected error:", error);
      }
    },

    setCurrentDateAsMaxDate() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;
      let day = now.getDate();

      let maxDate = `${year}-${month < 10 ? "0" + month : month}-${
        day < 10 ? "0" + day : day
      }`;

      return maxDate;
    },
    setCurrentTime() {
      let now = new Date();
      let hour = now.getHours();
      let minute = now.getMinutes();

      let currentTime = `${hour < 10 ? "0" + hour : hour}:${minute < 10 ? "0" + minute : minute}`;

      return currentTime;
    },
  },
  computed: {},
};
</script>

<style>
.container.loading {
  opacity: 0.2;
}

.forbidden_words span{
  margin-right: 5px;
}
</style>
